import { Component, OnChanges, OnInit, ElementRef, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FilterService } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { CancelParticipationService } from './../shared/providers/cancel-participation.service';
import { FanModel } from './../shared/models/cancel-participation.model';
import { Router, ActivatedRoute } from '@angular/router';
import { PageLoaderService } from './../../../../lib/ng2-sapmp/src/ui-components/page-loader/page-loader.service';
import { CANCELFANDATA } from 'config';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
@Component({
  selector: 'app-confirm-cancel',
  templateUrl: './confirm-cancel.component.html',
  styleUrls: ['./confirm-cancel.component.scss'],
  providers: [FilterService, CancelParticipationService],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmCancelComponent implements OnInit {

  formName: string;
  FANList: Array<FanModel>;
  UnclaimFANList: Array<FanModel>;
  gridOptions: GridOptionsModel;
  columnSelection: string;
  accordionList: any;
  accordionTitle: any;
  enableRouterLink: boolean;
  callingBackUrl: string;
  companyId: number;
  pageContent: any;
  unclaim: boolean;
  ibmflag: boolean;

  constructor(private cancelParticipationService: CancelParticipationService, private router: Router,
    private breadCrumbService: BreadCrumbService,  private pageLoaderService: PageLoaderService, 
    private utilityService: UtilityService, private route: ActivatedRoute) {
    this.FANList = [];
    this.enableRouterLink = false;
    this.companyId = 2;
    this.pageLoaderService.setPageLoaderStatus(false);
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.pageLoaderService.setPageLoaderStatus(false);
    this.formName = 'Cancel Participation - Confirm';
    this.unclaim = sessionStorage.getItem('unclaimFlag') ? JSON.parse(sessionStorage.getItem('unclaimFlag')) : false;
    this.ibmflag = sessionStorage.getItem('ibmflag') ? JSON.parse(sessionStorage.getItem('ibmflag')) : false;
    this.getFanData();
    this.isAllFansCancelled();
    this.cancelParticipationService.createPageLoadProperties('CONFIRM', 'confirm');
    if(this.ibmflag) {
      //this.callingBackUrl = sessionStorage.getItem('cancelCallingBackUrl');
      // (JSON.parse(sessionStorage.getItem('cancelCallingBackUrl')).callingPageUrl === 'manageInventory/deviceInventory' ?
      //   "/dashboard" : JSON.parse(sessionStorage.getItem('cancelCallingBackUrl')).callingPageUrl) : '/home';
      // if (this.callingBackUrl === 'manageInventory/deviceInventory') {
      //   this.callingBackUrl = '/dashboard';
      // } else {
      //   this.callingBackUrl = '/home';
      // }
      // sessionStorage.setItem('cancelCallingBackUrl', this.callingBackUrl);
      // Page Rendering
      this.cancelParticipationService.pageContent(this.utilityService.getEnvConfig().contentUrl.cancelParticipation.confirm).
        subscribe(respobj => {
          this.pageContent = respobj;
        });
    } else {
      this.pageContent = this.route.snapshot.data.pageData.cancelParticipationconfirm;
    }
    this.pageLoaderService.setPageLoaderStatus(true);
    //sessionStorage.setItem('cancelCallingBackUrl', '/cancelParticipation/confirm');
    
  }

  isAllFansCancelled() {
    const enrolledFan = this.cancelParticipationService.getReviewedFanData();
    const totalFan = this.cancelParticipationService.getCancelledFanData();
    const processingFanLength = totalFan.allFanList.filter(item => item.accountStatus !== 'PROCESSING').length;
  }

  getFanData() {
    const FanData = this.cancelParticipationService.getReviewedFanData();
    this.FANList = FanData.reviewedData;
    this.columnSelection = 'singlecol';
    this.initGrid();
  }

  
  backToFirstPage() {
    sessionStorage.removeItem('CancelParticipationData');
    sessionStorage.removeItem('UnclaimDevicesData');
    sessionStorage.removeItem('ReviewedData');
    sessionStorage.removeItem('RemovedData');
    sessionStorage.removeItem('unclaimFlag');
    this.router.navigate(['/dashboard']); 
  }

  backToCallingPage() {
    sessionStorage.removeItem('CancelParticipationData');
    sessionStorage.removeItem('ReviewedData');
    sessionStorage.removeItem('RemovedData');
    //this.router.navigate([this.callingBackUrl]);
    const previousUrl = sessionStorage.getItem('cancelCallingBackUrl');
    this.router.navigate([previousUrl]);
  }

  navToLearnPage() {
    sessionStorage.removeItem('CancelParticipationData');
    sessionStorage.removeItem('ReviewedData');
    sessionStorage.removeItem('RemovedData');
    sessionStorage.removeItem('unclaimFlag');
    //Changing from learn to home temporarily as a part of US-1367
    this.router.navigate(['/learn']);
  }

  navToHomePage() {
    sessionStorage.removeItem('CancelParticipationData');
    sessionStorage.removeItem('ReviewedData');
    sessionStorage.removeItem('RemovedData');
    sessionStorage.removeItem('unclaimFlag');
    this.router.navigate(['/home']);
  }

  initGrid() {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = false;
    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: this.FANList.length
    };
    options.Paginations = pagination;
    options.gridData = this.FANList;
    options.columnDefinitions = CANCELFANDATA.fanList[this.columnSelection].columnDefinitions;
    this.gridOptions = options;
  }
}
